<template>
    <div>
        <select
            v-if="userCreditCards && userCreditCards.data.length"
            v-model="selected"
            class="select-card"
            @change="selectHandler"
        >
            <option
                v-for="userCreditCard in userCreditCards.data"
                :value="userCreditCard.id"
            >
                {{ userCreditCard.type }} {{ userCreditCard.last_4_digits }}
                <span v-if="userCreditCard.banned">{{ $t('subscription.select_card.failed_card', {"service_advice": userCreditCard.banned}) }}</span>
            </option>
            <option value="0">{{ $t('subscription.select_card.new_card') }}</option>
        </select>

        <template
            class="form-container"
            v-if="optionSelected==0"
        >
            <PurchaseInovioPayForm
                :purchaseOption="purchaseOption"
                :paymentMethod="paymentMethod"
                :selectedCountry="selectedCountry"
                :hasToAcceptNoTrial="hasToAcceptNoTrial"
                :hasToAcceptNoPromo="hasToAcceptNoPromo"
                :resultMessage="resultMessage"
                :recurrent="recurrent"
                :paymentCountry="paymentCountryId"
                @loadingChange="loadingChange"
                @submit="submitHandlerForward"
            />
        
            <!--
            <div class="result-message" v-if="resultMessage">
                <p>
                    {{resultMessage}}
                </p>
            </div>
            -->
        </template>
        <template v-else >
            <PurchaseInovioPayOneClickPayment
                :subscriptionPlan="subscriptionPlan"
                :userCreditCard="selectedCard"
                :recurrent="recurrent"
                :paymentCountry="paymentCountryId"
                @loadingChange="loadingChange"
            />
        </template>
    </div>
</template>
<script>
import resources from "../../resources";
import EventBus from "../../eventbus";
import PurchaseInovioPayForm from './SubscriptionForm.Purchase.InovioPayForm';
import PurchaseInovioPayOneClickPayment from './SubscriptionForm.Purchase.InovioPayOneClickPayment';

export default {
    components: {
        PurchaseInovioPayForm,
        PurchaseInovioPayOneClickPayment
    },
    props: {
        purchaseOption: {
            type: Object,
            required: true,
        },
        hasToAcceptNoTrial: {
            required: true,
            default: false,
        },
        hasToAcceptNoPromo: {
            required: true,
            default: false,
        },
        resultMessage: {
            required: true,
        },
        paymentMethod: {
            required: true,
            type: Object,
        },
        selectedCountry: {
            required: false,
            type: Object,
        },
        recurrent: {
            required: true,
            type: Boolean,
            default: true
        },
        paymentCountry: {
            required: true,
        }
    },
    data(){
        return {
            selectedCard: null,
            selected: 0,
            paymentCountryId: null,
        };
    },
    mounted() {
        this.paymentCountryId = this.paymentCountry;

        // marca las tarjetas que tuvieron errores
        let failedCards =  JSON.parse(localStorage.getItem('failedCards')) || [];
        failedCards.reverse();
        this.userCreditCards && this.userCreditCards.data.map( card => {
            if(failedCards.some(failedCard => failedCard.id === card.id)){
                let failedCard = failedCards.find(failedCard => failedCard.id === card.id)
                card.banned = failedCard.details.SERVICE_ADVICE;
            }
        });
    
        // ordena para que los baneados aparezcan últimos
        this.userCreditCards && this.userCreditCards.data.sort((a,b) => a.banned ? 1 : 0)
    
        //setea la tarjeta default
        this.selected = (this.userCreditCards && this.userCreditCards.data.length) ? this.userCreditCards.data[0].id : false;
        this.selectHandler();
    },
    methods: {
        submitHandlerForward(event){
            this.$emit('submit', event);
        },
        loadingChange(event){
            this.$emit('loadingChange', event);
        },
        selectHandler(){
            this.selectedCard = (this.userCreditCards) ? this.userCreditCards.data.find( item => item.id == this.selected) : false;
        }
    },
    computed: {
        subscriptionPlan(){
            return this.purchaseOption.subscription_plan.data;
        },
        userCreditCards(){
            return this.purchaseOption.subscription_plan.data.one_click_pay_cards;
        },
        optionSelected(){
            return this.selected;
        },
    },
    watch: {
        paymentCountry(newVal) {
            this.paymentCountryId = newVal;
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.select-card{
    width: 100%;
    margin-bottom: 20px;
    padding: 10px 5px;
}
</style>